import { render, staticRenderFns } from "./Stage1.vue?vue&type=template&id=ea70aa10&scoped=true&"
import script from "./Stage1.vue?vue&type=script&lang=js&"
export * from "./Stage1.vue?vue&type=script&lang=js&"
import style0 from "./Stage1.vue?vue&type=style&index=0&id=ea70aa10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea70aa10",
  null
  
)

export default component.exports